




















import { Component } from 'vue-property-decorator';
import MixinPage from '@/plugins/podolib/services/helper/mixins/page';

import { TEntity, TState } from '@/plugins/podolib/services/entities/Entity';
import { TSoles } from '@/plugins/podolib/services/entities/EntitySoles';

import Page from '@/components/Page.vue';
import EquipmentsSoles from '@/components/equipments/EquipmentsSoles.vue';
import EquipmentsSolesNotice from '@/components/equipments/EquipmentsSolesNotice.vue';
import EquipmentsStations from '@/components/equipments/EquipmentsStations.vue';
import ElementUpdateSoles from '@/components/elements/dfu/ElementUpdateSoles.vue';

@Component({
  components: {
    Page,
    EquipmentsSoles,
    EquipmentsSolesNotice,
    EquipmentsStations,
    ElementUpdateSoles,
  },
  metaInfo() {
    return {
      title: this.$options.filters!.capitalize(this.$tc('commons.standards.equipment', 2)),
      titleTemplate: '%s | Podosmart',
    };
  },
  created() {
    this.$pdc.bus!.emitDebug('app:navbar:breadcrumbs', [
      {
        text: this.$tc('commons.standards.equipment', 2),
        disabled: false,
        to: '/equipments',
      },
    ]);
  },
})
export default class PageEquipments extends MixinPage {
  get soles(): TState<TEntity<TSoles>> {
    return this.$pdc.entities!.soles.storedEntity;
  }
  get getUpdatableSoles() {
    return this.$store.getters['pdc/entities/soles/getUpdatableSoles'];
  }
  get getCalibratableSoles() {
    return this.$store.getters['pdc/entities/soles/getCalibratableSoles'];
  }

  openUpdateDialog() {
    (this.$refs.update as any).open();
  }
}
